<template>
  <div class="[compoenent-name]-component">
    <!-- Use this sample to create new components -->
  </div>
</template>

<script>
/**
 * @name [Component name]
 * @description [Write component description]
 * @version [1.0.0]
 * @event [Write component events]
 * @property [Write component events]
 * @todo [Write Remaining task of this component here]
 * @link [Reference to task, documents etc.]
 *
 * @note: Replace [*] with new data and keep this comment above all components, for more information please
 follow https://jsdoc.app/index.html
 * @note To write document about props, methods and events you could use jsdoc.
 */
export default {

}
</script>

<style scoped>

</style>
